<template>
  <div id="NewTag2">
      <div class="all-owned-pets">
        <div v-if="loading" class="splash_screen">
            <lottie-animation
                ref="splash_screen"
                :speed="0"
                class="splash_screen"
                :animationData="require('@/assets/animation/splash.json')"
                :autoPlay="true"
                :loop="true"
                v-if="loading2"
              />
        </div>
        <section v-else-if="!newScan && !assignedPet">

          <p v-if="ownerdata.id == userID">You have claimed this tag but you have not assigned it to any pet.</p>
          <p v-else>This tag is claimed, but has not been assigned to a pet yet.</p>
          <button @click="refresh()" class="profile-action-btn btn" v-if="ownerdata.id != userID">Refresh to try again</button>

          <div class="unclaimed-pets-area" v-if="userID && displayClaimed">
            <p class="announce">Connect this device to... </p>
            <div class="unclaimed-pets" >
              <div class="unclaimed-pet"
                :class="{'selected': selected_pet == pet.pet_id}"
                v-for="(pet, idx) in claimed_pets"
                @click="pegTagToPet(pet.pet_id, pet.name)"
                :key="idx">
                <div
                  :style="{'background-image': 'url(' + pet.photo + ')'}"
                  class="profile-image">

                  <img class="tag-icons" :src="checked_icon" v-if="pet.tag_links.length == 1" />
                  <span class="tag-icons tag-count" v-else-if="pet.tag_links.length > 1">x{{pet.tag_links.length}}</span>
                  <img class="tag-icons" :src="caution_icon" v-else/>
                </div>
                <p class="pet-name">{{pet.name}}</p>
              </div>
            </div>
        </div>

          <button @click="gotoRoute('PetProfile')" class="profile-action-btn btn">Return Home</button>
      </section>
        <section v-else-if="newScan && !assignedPet">
          <br />
          <p class="announce" v-if="!displayUnclaimed && !displayClaimed">Please activate this device to your account</p>

          <div v-if="!processing">
            <button class="new-tag-btn"  v-if="!displayUnclaimed && !displayClaimed" @click="checkIfLoggedin()">
              Activate Device
            </button>
            <p class="announce feedback" v-if="feedback">{{feedback}}</p>
            <div class="unclaimed-pets-area" v-if="displayUnclaimed || displayClaimed">
              <p class="announce">Connect this device to... </p>
              <div class="unclaimed-pets">
              <div class="unclaimed-pet"
                :class="{'selected': selected_pet == pet.pet_id}"
                v-for="(pet, idx) in pets_list"
                @click="pegTagToPet(pet.pet_id, pet.name)"
                :key="idx">
                <div
                  :style="{'background-image': 'url(' + pet.photo + ')'}"
                  class="profile-image">
                  <img class="tag-icons" :src="checked_icon" v-if="pet.tag_links.length > 0" />
                  <img class="tag-icons" :src="caution_icon" v-else/>
                </div>
                <p class="pet-name">{{pet.name}}</p>
              </div>
            </div>
          </div>

          <button
            @click="activateDevice(userID)"
            class="profile-action-btn btn"
            v-if="displayUnclaimed || displayClaimed">Add to a Pet Later</button>

          </div>

          <div v-else-if="processing" class="splash_screen">
            <lottie-animation
              ref="splash_screen"
              :speed="0"
              class="splash_screen"
              :animationData="require('@/assets/animation/splash.json')"
              :autoPlay="true"
                :loop="true"
              v-if="processing"
            />
          </div>
          <br/>
          <div class="help-section">
            <p>If you need assistance please check out the links below</p>
            <br/>
            <ul class="helpful-links">
              <li><a
                href="https://heybuddy.club/pages/faq" target="_blank">FAQ</a></li>
              <li><a
                href="https://heybuddy.club/pages/tech-information"
                target="_blank">How to Set Up</a></li>
              <li><a
                href="https://heybuddy.club/pages/contact-us"
                target="_blank" >Contact</a></li>
            </ul>
          </div>
        </section>

      </div>
      <LocationDialog
			:open="showLocationDialog"
      :acceptance_status="acceptance_status"
      @toPet="toPet"
			@continue="requestUserLocation"
			@cancel="requestUserLocation"
		/>
  </div>
</template>

<script>
//This component only direct the user from tag id to username
import axios from 'axios'
import {fs, db} from '@/_firebase/init'
import {mapState, mapMutations} from 'vuex'
import LocationDialog from "@/petprofile/LocationDialog.vue"

const ERROR_404 = 'error_404';
const NOT_ACTIVATED = 'not_activated';
const ACTIVATED_NO_PET = 'activated_no_pet';
import LottieAnimation from "lottie-web-vue"

function getUserDevice() {
  let platform, vendor;
  if (navigator.userAgentData) {
    platform = navigator.userAgentData.platform;
    vendor = navigator.userAgentData.brands.map((brand) => `${brand.brand}; v${brand.version}`).join(", ");
  } else {
    platform = navigator.platform;
    vendor = navigator.vendor;
  }

  return {
    userAgent: navigator.userAgent,
    language: navigator.language,
    platform: platform,
    vendor: vendor,
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,

  };
}

export default {
  name: 'NewTag2',
  components:{
    LocationDialog,
		LottieAnimation
  },
  data(){
    return{
      // location:null,
      // errorStr:null,
      displayUnclaimed: false,
      unclaimed_pets: [],
      displayClaimed: false,
      claimed_pets: [],
      pets_list: [],
      feedback: '',
      selected_pet: '',
      showConfirmModal: false,
      pets_owned: [],
      ownerdata: {
        id: '',
        name:'',
        phone:'',
        address: '',
      },
      checked_icon: require('@/assets/svg/pet-card-icon/device-activated.svg'),
      caution_icon: require('@/assets/svg/pet-card-icon/warning.svg'),
      connected_pet_id: '',
      pets:[{photo:'', name: ''}],
      loading: true,
      loading2: false,
      processing: false,
      extra: '',
      uid: this.$route.params.id,
      serial_number: this.$route.query.sc,
      secure_code:this.$route.params.id,
      newScan: false,
      assignedPet: false,
      showLocationDialog: false,
      acceptance_status: ""
    }
  },
  methods:{
    ...mapMutations(['LOGOUT', 'SET_NEW_SCANED_TAG', 'ALERT_CODE', 'SET_CURRENT_LOCATION']),
    report(msg) {
        console.log('permissions', msg)
        this.acceptance_status = msg
        switch (msg) {
            case "granted":
                this.showLocationDialog = false;
                // alert('granted')
                this.getLocation();
                break;
            case "prompt":
                this.showLocationDialog = true;
                break;
            case "denied":
                this.showLocationDialog = false;
                // alert('location denied')
                this.getLocation();
                break;
        }
    },
    // isSafariOnMobile() {
    //     const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    //     const isMobile =true// /iPhone|iPod|iPad/i.test(navigator.userAgentData.platform);
    //     return isSafari && isMobile;
    // },
   isInAppBrowser() {
      var ua = navigator.userAgent || navigator.userAgentData.platform || window.opera;
      alert(`navigator.userAgent: ${navigator.userAgent} | ${navigator.userAgentData.platform}`)
      return /(fbav|twitter|instagram|pinterest|linkedin)/i.test(ua);
  },
    handlePermission() {
        navigator.permissions.query({ name: 'geolocation' }).then(result => {
          if (result.state !== 'prompt') {
                this.report(result.state);
            } else {
                // Just show your custom dialog. Do not request location here.
                // This is because Safari might show its native prompt immediately.
                this.showLocationDialog = true;
            }

            result.addEventListener("change", () => {
                this.report(result.state);
                if (result.state !== "granted") {
                    this.checkTag(this.serial_number);
                }
            });
        });
    },
    requestUserLocation() {
      console.log('clicked')
        navigator.geolocation.getCurrentPosition(() => {
            this.report('granted');
            localStorage.setItem('geoPermission', 'granted');
        }, err => {
          console.log('err', err)
            if (err.code === err.PERMISSION_DENIED) {
                this.report('denied');
                localStorage.setItem('geoPermission', 'denied');
            } else {
                console.log('err', err)
                console.log('err.PERMISSION_DENIED', err.PERMISSION_DENIED)
                this.report('error');
            }
        });
    },
    toPet(){
      navigator.geolocation.getCurrentPosition(() => {
            this.report('granted');
            localStorage.setItem('geoPermission', 'granted');
        }, err => {
          console.log('err', err)
            if (err.code === err.PERMISSION_DENIED) {
                this.report('denied');
                localStorage.setItem('geoPermission', 'denied');
            } else {
                console.log('err', err)
                console.log('err.PERMISSION_DENIED', err.PERMISSION_DENIED)
                this.report('error');
            }
        });
    },
    manageScan(){
      this.loading = true
      let payload = {
          secure_code: this.uid,
          serial_number: this.serial_number,
          serial_code: this.serial_number,
          source: "mobile",
          userDevice: "",
          coordinates:{
              latitude: 0,
              longitude: 0
          }
        }
      if(this.serial_number == null){
        //only for old users
        const sc_num =  Number(this.uid.replace("BB", ""))
        if(sc_num <= 9035){
          payload = {
            secure_code: "",
            serial_number: this.uid,
            serial_code: this.uid,
            source: "mobile",
            userDevice: "",
            coordinates:{
                latitude: 0,
                longitude: 0
            }
          }
        }else{
          this.$router.push({name: 'NotFound'})
        }
      }
        console.log('getting payload', payload)

      axios.post(`${this.$api_path}/devices/find`, payload).then((res)=>{
        console.log("🔴 find device", res.data)
        console.log('getting res data', res.data)
        const result = res.data
        console.log("result", res.data)
        this.serial_code = res.data.results.serial_code
        this.serial_number = res.data.results.serial_number//s//serial_code
        this.secure_code = res.data.results.secure_code
        // if(result['action'] == 'activated_tag' || result['action'] == 'activated_no_pet'){
        if(result['action'] == 'activated_tag'){
          this.extra = result.extra
          // this.isInAppBrowser()
          // console.log("result before results pet_id", result['results'])
          // this.checkTag(this.serial_number)
          this.getLocation()
          // if(result['results']['owner']['pet_id'] == ''){
          //   this.checkTag(this.serial_number)
          // }else{
          //   this.getLocation()
          // }
          // this.handlePermission();
        }
        else if(result['action'] == 'not_activated' || result['action'] == 'activated_no_pet'){
          console.log('getting activated_no_pet?',result)
          this.checkTag(this.serial_number)
        }
        else if(result['action'] == 'doesnt_exists'){
          this.$router.push({name: 'NotFound'})
        }
      }).catch((err)=>{
        console.log(err)
      })
    },
    getLocation() {
      this.showLocationDialog = false;
      this.loading2 = true
      if(!("geolocation" in navigator)) {
        this.errorStr = 'Geolocation is not available.';
        return;
      }
      // console.log('getting location')
      navigator.geolocation.getCurrentPosition(pos =>{
        let lat = pos.coords.latitude
        let long = pos.coords.longitude
        this.location = {latitude: lat, longitude: long}
        this.SET_CURRENT_LOCATION({lat, long})
        this.checkTag(this.serial_number)
      }, err =>{
        console.log(err)
        this.checkTag(this.serial_number)
      },{timeout:10000})
    },
    errorLocation(err){console.log(err); alert(err.message);},
    refresh(){
      location.reload()
    },
    toggleModal(val){
      this.showConfirmModal = val
    },
    readQRCode(){
          // let file = evt.target.files[0];
          // console.log(file)
        },
    gotoRoute(rotue){
      this.$router.push({name: rotue})
    },
    async checkTag(serial_number) {
      const userDevice = getUserDevice();
      // console.log("secure code", this.secure_code)
      // console.log("serial_number", serial_number)
      let payload = {
        secure_code: this.secure_code,
        serial_number: serial_number,
        userDevice: userDevice.platform,
        source: 'webapp',
        coordinates: this.location || { latitude: null, longitude: null }
      };
      this.loading = true;
        console.log("loading res.data on scan", payload)
      try {
        // console.log("🔴 payload", payload)
        const res = await axios.post(`${this.$api_path}/devices/scan`, payload);
        // console.log("res.data on scan", res.data)
        const scan = res.data;
        const tag_data =  res.data.result;
        // console.log("🔴 scan", scan)

        this.loading = false;

        // console.log('scan.action', scan.action)

        switch (scan.action) {
          case ERROR_404:
            this.$router.push({ name: 'NotFound' });
            break;

          case NOT_ACTIVATED:
            this.newScan = true;
            this.SET_NEW_SCANED_TAG(serial_number);
            this.$router.push({ name: 'OnboardingMain' });
            break;

          default: // Check if scan is activated
            this.newScan = false;
            // console.log("tag_data",  tag_data)
            this.ownerdata.id = tag_data._id;
            this.connected_pet_id = tag_data.petID;
            if (scan.action === ACTIVATED_NO_PET) {
              this.assignedPet = false;
              this.$router.push({ name: 'OnboardingMain' });
            } else {
              this.assignedPet = true;
              // console.log("tag_data tag_data", this.tag_data)
              if(tag_data.petID != ''){
                this.getUserData(tag_data.petID);
              }else{
                this.connected_pet_id = tag_data.owner.pet_id
                this.getUserData(tag_data.owner.pet_id);
              }
            }
            break;
        }
      } catch (err) {
        this.$router.push({ name: 'OnboardingMain' });
        console.error('err', err);
        this.loading = false;
      }
    },
    async activateDevice(userID){
      this.processing = true
      const now = new Date()
      const epoch_time = Math.round(now / 1000)

      const deviceRef = db.collection('devices').doc(this.serial_number);
      let data = {
        activated: true,
        date_activated: epoch_time,
        userDevice: navigator.platform,
        owner:{
          _id: userID,
          pet_id: ''
        }
      }
      await deviceRef.update(data);

      const userRef = db.collection('users').doc(this.userID);
      let user_update_data = {
        tags_owned: fs.FieldValue.arrayUnion(this.serial_number)
      }
      await userRef.update(user_update_data);
      this.processing = false
      this.$router.push({name: 'PetProfile'})
    },
    async getUserData(pid) {
      this.loading = true;
      try {
        const response = await axios.get(`${this.$api_path}/pets/${pid}/guest`)
        // console.log("response guest", response.data)
        if (response.data.status == "success") {
          this.ownerdata.name = response.data.result.user.username;
          this.newScan = false;
          this.gotoScannedPage();
        } else {
          this.newScan = true;
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        this.newScan = true;
      } finally {
        this.loading = false;
      }
    },
    gotoScannedPage(){
      this.$store.commit('SET_OWNER_ID', this.ownerdata.id)
      if( this.ownerdata.id != this.userID){
        this.$router.push({name: 'ScannedPage', params:{
          username: this.ownerdata.name,
          pet_id: this.connected_pet_id}})
      }else{
        this.$router.push({name: 'PetPage', params:{pet_id: this.connected_pet_id}})
      }
    },
    setSession() {
      const currentTime = Math.floor(Date.now() / 1000); // Get the current timestamp in seconds as an integer
      this.$store.commit('UPDATE_LAST_VISITED', currentTime); // Commit a mutation to the Vuex store
    }
  },
  computed:{
    ...mapState(['userID', 'onboarding_point']),
  },
  created(){
    this.LOGOUT()
    this.manageScan()
    // this.$store.commit('REMOVE_OWNER_ID')
  },
  mounted(){
    this.setSession()
    // if(location == null){
    //     this.checkTag()
    // }
  }
}
</script>
<style scoped>
#NewTag2{
  margin: auto;
  padding: 1rem 0;
  max-width: 900px;
  min-height: 90vh;
  background-color: #7523F2;
}
.profile-image{
  width: 6rem;
  height: 6rem;
  transition:1s;
  border-radius: 10px;
  position: relative;
  /* Create the parallax scrolling effect */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.tag-icons{
  width: 2rem;
  position: absolute;
  bottom: -.5rem;
  right: -.5rem;
}
.tag-count{
  display:flex;
  justify-content: center;
  align-items:center;
  width: 2rem;
  height: 2rem;
  font-size: 14px;
  background-color: var(--primary);
  color: var(--secondary);
  border-radius: 100%;
}
.unclaimed-pets-area{
  margin: 2rem 0;
  width: 100%;
  padding:0;
}
.unclaimed-pets{
  margin-top: 2rem;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  justify-items: center;
  align-items: center;
  transition: 1s;
}
.unclaimed-pet{
  margin: 0 auto;
  padding: 0 .5rem;
  padding-top: .5rem;
  max-width: 7rem;
  display: flex;
  flex-direction: column;
  align-items:center;
  cursor:pointer;
  justify-content: center;
  transition: 1s;
}
.unclaimed-pet:hover, .selected{
  transform: translateY(-5px);
  border-radius: 0px;
  box-shadow: 1px 1px 18px -2px rgba(115,103,103,0.75);
  -webkit-box-shadow: 1px 1px 18px -2px rgba(115,103,103,0.75);
  -moz-box-shadow: 1px 1px 18px -2px rgba(115,103,103,0.75);
  transform: translate(-6px, -9px);
  border-radius: 10px;
}
.pet-name{
  color:  #5197FF;
  font-weight: bold;
  font-size: 1.1rem;
  margin: .6rem auto;
}
.new-tag-btn{
  background-color: var(--primary);
  text-align:center;
  border: none;
  border-radius: 10px;
  font-size: 1.2rem;
  padding: 1rem 1.1rem;
  color: #fff;
  width: 60%;
  margin: 2rem auto;
  cursor: pointer;
  transition: 1s;
}
.all-owned-pets{
  width: 90%;
  margin: auto;
  text-align:center;
}
.splash_screen {
	position: fixed;
	left: 50%;
	transform: translateX(-50%);
	z-index: 109;
	height: 110vh;
	width: 900px;
	background-color: #7523F2;
	background-size: cover;
	background-position: center;
}
.loading-box img{
  width: 80%;
  margin: auto;
}
.edit-btn{
  display: flex;
}
.edit-btn-group{
    display: flex;
  justify-content: space-between;
}
.profile-action-btn{
  margin-top: 2rem auto;
  width: 60%;
  padding: .6rem .2rem;
}
.announce{
  font-size: 1.2rem;
}
.feedback{
  width: 80%;
  margin: auto;
}
.help-section{
  text-align: left;
  margin: auto;
  width: 80%;
}

.helpful-links li{
  margin: 1rem 0;
  font-size: 1.2rem;
}
@media only screen and (max-width: 600px) {

}
</style>
